<p> {{ data.text }}</p>
<button mat-raised-button (click)="close(true)">{{data.buttonText}}</button>
